import React, { useMemo } from "react";
import PropTypes from "prop-types";
import {
  Heading,
  HStack,
  Image,
  Pressable,
  Stack,
  Text,
  VStack,
} from "native-base";
import { FaShareAlt } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import moment from "moment";
import styles from "./styles.module.css";
import bus from "../../assets/icons/bus.svg";
import location from "../../assets/icons/location.svg";
import seat from "../../assets/icons/seat.svg";
import calendar from "../../assets/icons/calendar.svg";
import colors from "../../constants/colors";
import routes from "../../routes";
import { useDisclose } from "../../hooks/useDisclose";
import Modal from "../modal";
import Itinerary from "../itinerary";
import DownloadItineraryButton from "../downloadItineraryButton";

function Tour(props) {
  const { tour, index, role } = props;
  const { isOpen: isItineraryOpen, onToggle: onToggleItinerary } =
    useDisclose();

  const origin = useMemo(
    () =>
      tour.itinerary.find(
        (location) => !location.isReturn && location.type === "origin",
      ),
    [tour],
  );

  const destination = useMemo(
    () =>
      tour.itinerary.find(
        (location) => !location.isReturn && location.type === "destination",
      ),
    [tour],
  );

  console.debug(isItineraryOpen);

  return (
    <VStack
      padding={6}
      backgroundColor="white"
      borderRadius={5}
      space={5}
      minWidth={300}
      maxWidth={400}
      width="full"
      marginLeft={index % 3 === 0 ? 0 : "2%"}
      marginBottom={5}
      shadow="1">
      <HStack>
        <Heading fontSize="lg" flex={1}>
          {tour?.name || destination?.name}
        </Heading>
        <Pressable
          backgroundColor={colors.primary}
          borderRadius={5}
          padding={2}>
          <FaShareAlt color={colors.white} />
        </Pressable>
      </HStack>
      <HStack space={5}>
        <HStack>
          <Text bold>Folio: </Text>
          <Text>{tour.id}</Text>
        </HStack>
        <HStack>
          <Text bold>Estado: </Text>
          <Text>{tour.status ? "Confirmado" : "Pendiente"}</Text>
        </HStack>
      </HStack>
      <HStack space={1}>
        <Image
          src={bus}
          alt="bus"
          width={25}
          height={25}
          tintColor={colors.secondary}
        />
        <Text flex={1}>{origin?.name}</Text>
      </HStack>
      <HStack space={1}>
        <Image
          src={location}
          alt="location"
          width={25}
          height={25}
          tintColor={colors.secondary}
        />
        <Text flex={1}>{destination?.name}</Text>
      </HStack>
      <HStack>
        <HStack flex={1} space={1}>
          <Image
            src={seat}
            alt="seat"
            width={25}
            height={25}
            tintColor={colors.secondary}
          />
          <Text>
            {tour.services.reduce(
              (total, service) =>
                total + service.quotation.vehicleType.capacity,
              0,
            )}
          </Text>
        </HStack>
        <HStack flex={1} space={1}>
          <Image
            src={calendar}
            alt="calendar"
            width={25}
            height={25}
            tintColor={colors.secondary}
          />
          <Text>
            {moment(origin?.departureDate).format(moment.HTML5_FMT.DATE)}{" "}
            {moment(origin?.departureDate).format(moment.HTML5_FMT.TIME)}
          </Text>
        </HStack>
      </HStack>
      {role === "agency" && (
        <HStack space={2}>
          <VStack flex={1} alignItems="center" space={5}>
            <Link
              className={styles.link}
              to={routes.agencyPaymentManagementInstallments.replace(
                ":id",
                tour.id,
              )}>
              <Stack
                backgroundColor={colors.primary}
                borderRadius="full"
                paddingY={3}
                maxWidth={130}
                width="100%"
                alignItems="center">
                <Text color={colors.white} lineHeight={16}>
                  Abonos
                </Text>
              </Stack>
            </Link>
            <Link
              className={styles.link}
              to={routes.agencyPaymentManagementServices.replace(
                ":id",
                tour.id,
              )}>
              <Stack
                backgroundColor={colors.primary}
                borderRadius="full"
                paddingY={3}
                maxWidth={170}
                width="100%"
                alignItems="center">
                <Text color={colors.white} textAlign="center" lineHeight={16}>
                  Ver servicios
                </Text>
              </Stack>
            </Link>
          </VStack>
          <Stack flex={1} alignItems="center">
            <Link
              to={routes.agencyPaymentManagementPricing.replace(
                ":id",
                tour.id,
              )}>
              <Stack
                backgroundColor={colors.primary}
                borderRadius={5}
                padding={3}
                maxWidth={170}>
                <Text color={colors.white} textAlign="center" lineHeight={16}>
                  Asignación de <br />
                  precios
                </Text>
              </Stack>
            </Link>
          </Stack>
        </HStack>
      )}
      {role === "user" && (
        <HStack justifyContent="center" space={5}>
          <button className={styles.link} onClick={onToggleItinerary}>
            <Stack
              backgroundColor={colors.primary}
              borderRadius="full"
              paddingY={3}
              maxWidth={130}
              width="100%"
              alignItems="center">
              <Text color={colors.white} lineHeight={16}>
                Itinerario
              </Text>
            </Stack>
          </button>
          <Modal isOpen={isItineraryOpen} onRequestClose={onToggleItinerary}>
            <VStack space={5} overflow="hidden" padding={5}>
              <HStack>
                <Text bold flex={1} textAlign="center" fontSize="xl">
                  Tour #{tour.id}
                </Text>
                <button onClick={onToggleItinerary}>
                  <MdClose size={25} />
                </button>
              </HStack>
              <Itinerary detailed itinerary={tour.itinerary} />
              <HStack justifyContent="center">
                <DownloadItineraryButton
                  id={tour.id}
                  itinerary={tour.itinerary}
                />
              </HStack>
            </VStack>
          </Modal>
          <Link
            className={styles.link}
            to={routes.tripsInstallments.replace(":id", tour.id)}>
            <Stack
              backgroundColor={colors.primary}
              borderRadius="full"
              paddingY={3}
              maxWidth={130}
              width="100%"
              alignItems="center">
              <Text color={colors.white} lineHeight={16}>
                Abonos
              </Text>
            </Stack>
          </Link>
        </HStack>
      )}
    </VStack>
  );
}

Tour.propTypes = {
  tour: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  role: PropTypes.string,
};

Tour.defaultProps = {
  role: "agency",
};

export default React.memo(Tour);
